/**
 * @license
 * jquery.smoothscroll.js - jQuery plugin to animate scrolling to anchor links
 * Version 1.0.4 (Aug 19, 2017)
 * Copyright 2017 Kite - https://github.com/ixkaito
 * MIT License
 */
(function($, undefined) {

  'use strict';

  $.fn.smoothscroll = function(options) {

    var defaults = {
      duration:  400,
      easing: 'swing',
      offset: 0,
      hash: true,
      focus: true,
    };

    var config = $.extend(true, {}, defaults, options);

    return this.each(function() {
      $(this).on('click', function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var hash = this.hash;
          var $target = hash ? $(hash) : $('html');
          $target = $target.length ? $target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if ($target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').stop().animate({
              scrollTop: $target.offset().top + config.offset,
            }, config.duration, config.easing, function() {
              // Callback after animation
              // Add the target hash to the end of the URL
              if (config.hash) {
                if (history.pushState) {
                  history.pushState(null, null, hash);
                } else if (0 == config.offset) {
                  window.location.hash = hash;
                } else { // Fallback on old browsers without history API.
                  var operator = (config.offset > 0 ? '+' : '-');
                  window.location.hash = hash + '-offset-' + operator + Math.abs(config.offset);
                }
              }
              if (config.focus) {
                // Must change focus!
                $target.focus();
                if ($target.is(':focus')) { // Checking if the target was focused
                  return false;
                } else {
                  $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                }
              }
            });
          }
        }
      });
    });

  };

})(jQuery);

$( window ).on("load", function() {
  $("body").removeClass("blue-bg");
  $(".homepage-slider-container").removeClass("img-hidden");
});


$(document).ready(function () {
  // setTimeout(function () {
  //   $(".flow-homepage").trigger( "click" );
  // }, 100);

  // 2026-10-03: only take over the link when its scroll target is on the page. The home page's visual navigation banner
  // is switched off, so this threw a TypeError on every tap of the hero's second button; the button's own link
  // (e.g. #why-clearer) now handles it.
  $ ('.template-index .secondry_btn') .click(function () {
  var target = $ (".visual-nav-banner");
  if (!target.length) return;
  $ ('html, body') .animate ({
  scrollTop: target.offset().top-70
  }, 100);
  return false;
  });

  $ ('body#seeing-spots-and-squiggly-lines .secondry_btn') .click(function () {
  var target = $ ('[data-wetheme-section-type="text--rich-text"]');
  if (!target.length) return;
  $ ('html, body') .animate ({
  scrollTop: target.offset().top-70
  }, 100);
  return false;
  });
  
  
  $ ("a[href*='home_product']") .click(function () {
  $ ('html, body') .animate ({
  scrollTop: $ ("#product-box") .offset().top
  }, 100);
  return false;
  });
  
});

$(document).ready(function () {
  setTimeout(function() {
    $(".gsdiscountinput").insertAfter("#sidebar-collapse");
  }, 2000);
  $('#applydiscount').on("click", function() {
    $(".gsdiscountinput").show();
  });
});

$(document).ready(function () {
  $(".gsdiscountinput").hide();
$('div#sidebar-collapse').click(function(){
  if ( $(".gsdiscountinput").is(":visible") ) { 
    $(".gsdiscountinput").hide(1000); 
  } else if ( $(".gsdiscountinput").is(":hidden") ) { 
    $(".gsdiscountinput").show(1000); 
  }
});

});


$(document).on('change', '.swatch .swatch-element input', function() {
    var val_swatch = $(this).val();

    // Remove any previous classes added by other swatches
    $('.sealsubs-container').removeClass(function(index, className) {
        return (className.match(/(^|\s)swatch-\S+/g) || []).join(' ');
    });

    // Check if val_swatch contains '6' using a regular expression
    if (/6/.test(val_swatch)) {
        // Add the class if val_swatch contains '6'
        $('.sealsubs-container').addClass('swatch-' + val_swatch);
    }

    if (val_swatch.includes("6")) {
    console.log("val_swatch contains 6");
    $('.skio-plan-picker').css('display','none');
    $('.purchase-options__title').css('display','none');
}
  
});


$(window).on('load', function () {
  if ($('body').hasClass('template-index')) {
    $('.swatch-element.single-bottle.available input').trigger('click');
  }

   var variant__val = $('.swatch .swatch-element input:checked').val();
console.log(variant__val);
    // Guard added 27 Sep 2026: pages without the old variant swatches (e.g. the new Clearer product section) have no checked swatch.
    if (variant__val && variant__val.includes("6")) {
    console.log("val_swatch contains 6");
    $('.skio-plan-picker').css('display','none');
    $('.purchase-options__title').css('display','none');
}
  
});
